import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/xt-fund-trans/";

//小额资产配置信息，阙值/单位
export function getLimitConfig(config?) {
  return XtAxios4.get(URL + `fund/convert/getConfig`, config);
}

//锁仓冻结情况
export function getFrozenSummary(config?) {
  return XtAxios4.get(URL + `private/user-lock-position/frozen-summary`, config);
}

//解锁记录
export function getUnlockRecord(config?) {
  return XtAxios4.get(URL + `private/user-lock-position/unlockRecord`, config);
}

//查询估值
export function getConvertEvaluate(config) {
  return XtAxios4.post(URL + `fund/convert/doEvaluate`, null, config);
}

//资产兑换
export function doConvert(config) {
  return XtAxios4.post(URL + `fund/convert/doConvert`, null, config);
}

//小额资产兑换列表
export function getConvertRecord(config?) {
  return XtAxios4.get(URL + `fund/convert/list`, config);
}
